import { APIResponse } from '../api';

export type WebEvent = {
  url: string;
  hostname: string;
  categories: number[];
  categories_match: number[];
  action: ReportSiteAction;
  reason: ReportSiteReason;
};

export type ScreenTimeEvent = {
  ts: number;
  seconds: number;
};

export enum ReportSiteAction {
  ALLOW = 0,
  BLOCK = 1,
  ALERT = 2,
  IGNORE = 3,
}

export enum ReportSiteReason {
  NO_MATCH = 0,
  WHITELIST = 1,
  CATEGORY_BLOCK = 7,
  NOT_ALLOW_UNKNOWN_SITES = 9,
}

export type EventsReportResponse = APIResponse<
  {
    screen_time: {
      date: string;
      profile_uid: string;
      seconds: number;
    };
  },
  Headers
>;
